import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { setFilters } from '@/app/common/reducers/filterSlice';
import { convertToQueryString } from '@/utils/queryString';
import type {
  AdvancedFilterField,
  AdvancedFiltersState,
  FiltersRootState
} from '@/app/common/components/filters/filterTypes';

const LONG_KEYWORDS_MIN_WORDS_COUNT = '5';

const longKeywordsFilter: AdvancedFilterField = {
  title: 'طول',
  operator: 'and',
  filterModes: [
    {
      mode: 'greaterthanorequals',
      value: LONG_KEYWORDS_MIN_WORDS_COUNT,
      key: 1
    }
  ]
};

const isLongKeywordsFilterActive = (filters: AdvancedFiltersState) => {
  const wordsCountFilter = filters.words_count;

  return (
    wordsCountFilter?.filterModes?.some(
      mode =>
        mode.mode === 'greaterthanorequals' &&
        mode.value === LONG_KEYWORDS_MIN_WORDS_COUNT
    ) ?? false
  );
};

const RelatedLongKeywordsFilter = () => {
  const dispatch = useDispatch();
  const currentFilters = useSelector(
    (state: FiltersRootState) => state.filters
  );
  const [, setSearchParams] = useSearchParams();
  const active = isLongKeywordsFilterActive(currentFilters);

  const handleToggle = () => {
    if (active) {
      const { words_count: _removed, ...restFilters } = currentFilters;
      dispatch(setFilters(restFilters));
      setSearchParams(convertToQueryString(restFilters));
      return;
    }

    const nextFilters: AdvancedFiltersState = {
      ...currentFilters,
      words_count: longKeywordsFilter
    };

    dispatch(setFilters(nextFilters));
    setSearchParams(convertToQueryString(nextFilters));
  };

  return (
    <Button
      size="lg"
      variant="secondary"
      active={active}
      onClick={handleToggle}
      className="m-0 fs-0 h-100 cursor-pointer d-flex align-items-center"
    >
      کلمات طولانی
    </Button>
  );
};

export default RelatedLongKeywordsFilter;
